import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { NavigationTypeEnum } from '@/shared/constant/navigation/Navigation';
import { ScreenSize } from '@/shared/constant/ScreenSize';
import React from 'react';

export function useCalcNavbarHeight() {
  const isMobileSize = useAppearanceConfigModelStore((x) => x.screenSize === ScreenSize.Mobile);
  const type = useDocsDataModelStore((x) => x.navigation.type);
  const height = React.useMemo(() => {
    if (!isMobileSize) {
      if (type === NavigationTypeEnum.None) {
        return 0;
      } else if (type === NavigationTypeEnum.FirstLevelNavigation) {
        return 56 + 1;
      }
    }

    return 106 + 1;
  }, [type, isMobileSize]);

  return height;
}
